import { Mutation } from '@apollo/client/react/components';

import ConfirmDeleteModal from '~/components/ConfirmDeleteModal';
import history from '~/lib/history';
import paths from '~/lib/paths';

import mutation from './mutation.graphql';

export default class AudiencesDestroyHandler extends React.Component {
  state = {
    isConfirmModalOpen: false,
  };

  closeConfirmModal = () => {
    this.setState({ isConfirmModalOpen: false });
  };

  handleClick = () => {
    this.setState({ isConfirmModalOpen: true });
  };

  handleCompleted = () => {
    const path = paths.audiences();
    history.push(path);
  };

  render() {
    const { audience, children } = this.props;
    const { isConfirmModalOpen } = this.state;

    const variables = {
      input: {
        id: audience.id,
      },
    };

    return (
      <Mutation
        mutation={mutation}
        onCompleted={this.handleCompleted}
        variables={variables}>
        {(destroyAudience, { loading }) => (
          <>
            {React.cloneElement(children, {
              disabled: loading,
              onClick: this.handleClick,
            })}

            <ConfirmDeleteModal
              canDelete
              closeModal={this.closeConfirmModal}
              deleteItem={destroyAudience}
              open={isConfirmModalOpen}
              subTitle="You are deleting this audience from Clearbit. The audience will remain in Facebook, but no additional audience syncs from Clearbit will occur."
              type="audience"
            />
          </>
        )}
      </Mutation>
    );
  }
}

AudiencesDestroyHandler.propTypes = {
  audience: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};
